import { render } from "./Root.vue?vue&type=template&id=5ffd42b3&scoped=true&ts=true"
import script from "./Root.vue?vue&type=script&lang=ts"
export * from "./Root.vue?vue&type=script&lang=ts"

import "./Root.vue?vue&type=style&index=0&id=5ffd42b3&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffd42b3"]])

export default __exports__